import { apiv3Url } from "../../../../_metronic/_helpers";
import axios from "axios";

export const LOGIN_URL = `${apiv3Url}/api/auth/login2`;
export const LOGIN_VERIFY_URL = `${apiv3Url}/api/auth/login2/verify`;
export const CHANGE_PASSWORD_URL = `${apiv3Url}/api/auth/change-password`;
export const TOKEN_CEK_URL = `${apiv3Url}/api/auth/checkToken`;
export const TOKEN_REFRESH_URL = `${apiv3Url}/api/auth/refreshToken`;
export const REGISTER_URL = "api/auth/register";
export const REQUEST_PASSWORD_URL = `${apiv3Url}/api/auth/forgot-password`;
export const LOGOUT_URL = `${apiv3Url}/api/auth/logout`;

// export const ME_URL = `${apiUrl}/user-service/user/me`;
export const ME_URL = `${apiv3Url}/user-cqrs-service/user/simple/null`;

export function login(nik, password) {
  return axios.post(LOGIN_URL, { nik, password });
}

export function verifyLoginTwoFactor(nik, password, code) {
  return axios.post(LOGIN_VERIFY_URL, { nik, password, code });
}

export function cekToken(token) {
  return axios.post(TOKEN_CEK_URL, { token: token });
}

export function logout(token, key_multi_app) {
  return axios.post(LOGOUT_URL, { token: token, key_multi_app: key_multi_app });
}

export function refreshToken(key_multi_app) {
  return axios.post(TOKEN_REFRESH_URL, { key_multi_app: key_multi_app });
}

export function register(email, fullname, username, password) {
  return axios.post(REGISTER_URL, { email, fullname, username, password });
}

export function requestPassword(email) {
  return axios.post(REQUEST_PASSWORD_URL, { email });
}

export const RESET_PASSWORD_URL = `${apiv3Url}/api/auth/reset-password`;

export function resetPassword(token, email, new_password, confirm_password) {
  return axios.post(RESET_PASSWORD_URL, {
    token,
    email,
    new_password,
    confirm_password,
  });
}

export function changePassword(
  nik,
  old_password,
  new_password,
  confirm_password,
) {
  return axios.post(CHANGE_PASSWORD_URL, {
    nik: nik,
    password: old_password,
    new_password: new_password,
    confirm_password: confirm_password,
  });
}

export function getUserByToken(token) {
  // Authorization head should be fulfilled in interceptor.
  return axios.get(ME_URL);
}

export const TWO_FACTOR_ENABLE_URL = `${apiv3Url}/api/auth/two-factor/enable`;
export const TWO_FACTOR_CONFIRM_URL = `${apiv3Url}/api/auth/two-factor/confirm`;
export const TWO_FACTOR_DISABLE_URL = `${apiv3Url}/api/auth/two-factor/disable`;
export const TWO_FACTOR_RECOVERY_CODES_URL = `${apiv3Url}/api/auth/two-factor/recovery-codes`;
export const TWO_FACTOR_REGENERATE_URL = `${apiv3Url}/api/auth/two-factor/regenerate-recovery-codes`;

export function enable2fa() {
  return axios.post(TWO_FACTOR_ENABLE_URL);
}

export function confirm2fa(code) {
  return axios.post(TWO_FACTOR_CONFIRM_URL, { code });
}

export function disable2fa() {
  return axios.post(TWO_FACTOR_DISABLE_URL);
}

export function fetchRecoveryCodes() {
  return axios.get(TWO_FACTOR_RECOVERY_CODES_URL);
}

export function regenerateRecoveryCodes() {
  return axios.post(TWO_FACTOR_REGENERATE_URL);
}

export const UPDATE_PROFILE_URL = `${apiv3Url}/api/auth/profile`;

export function updateProfile(name, email) {
  return axios.post(UPDATE_PROFILE_URL, { name, email });
}
